module.exports = __webpack_public_path__ + "static/media/tl.3c1ccf11.svg";